import { UserInteractionHandlerTypes } from '../user-interaction-handler-types';

export type UserInteractionHandlerFactoryMethod<T extends keyof UserInteractionHandlerTypes> =
  (args: UserInteractionHandlerTypes[T]['args']) => UserInteractionHandlerTypes[T]['ctor'];
